import { render, staticRenderFns } from "./TrsaccGroupAcnoTab.vue?vue&type=template&id=81135f5a"
import script from "./TrsaccGroupAcnoTab.vue?vue&type=script&lang=js"
export * from "./TrsaccGroupAcnoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81135f5a')) {
      api.createRecord('81135f5a', component.options)
    } else {
      api.reload('81135f5a', component.options)
    }
    module.hot.accept("./TrsaccGroupAcnoTab.vue?vue&type=template&id=81135f5a", function () {
      api.rerender('81135f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/transfer/TrsaccGroupAcnoTab.vue"
export default component.exports